import React, { Fragment, memo } from "react";
import "./PickListDetailsRow.css";
import {
  useTheme,
  Select,
  Input,
  MenuItem,
  TableRow,
  TableCell,
  Checkbox,
  IconButton,
  useMediaQuery,
  Tooltip,
  Link,
} from "@mui/material";

import { useLocation } from "react-router-dom";

import { useSelector } from "react-redux";
import Substitution from "../../../../components/Dialogs/Substitution/Substitution";
import Subitems from "../../../../components/Dialogs/Subitems/Subitems";
import Fees from "../../../../components/Dialogs/Fees/Fees";

import AutoDeleteIcon from "@mui/icons-material/AutoDelete";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import CheckIcon from "@mui/icons-material/Check";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const PickListDetailsRow = (props) => {
  const location = useLocation();
  const theme = useTheme();

  const xsWidth = useMediaQuery(theme.breakpoints.only("xs"));

  const {
    columns,
    hidePicked,
    hideAdditionals,
    index,
    locked,
    row,
    handleChange,
    handleSubitemsChange,
    handleFeesChange,
  } = props;

  const currentUserStore = useSelector((state) => state.current_user);

  // todo: sortingState prop is being sent but not used atm
  const { bulkState } = location.state;

  const overriddenButton = (name) => (
    <IconButton
      aria-label="reset overridden value"
      onClick={() =>
        handleChange({
          target: {
            name: name,
            value: "_reset_overridden",
          },
        })
      }
    >
      <RestartAltIcon />
    </IconButton>
  );
  const overriddenStyle = (columnId, item) => {
    let bgColor = "inherit";

    if (["units_ordered", "cases_ordered"].includes(columnId)) {
      bgColor = "#eee";
    }

    if (
      columnId === "units_ordered" &&
      ["Unit", "Unit / Case"].includes(row.unit_type) &&
      item.units_originally_ordered &&
      item.units_originally_ordered !== null &&
      item.units_originally_ordered !== +item.units_ordered
    ) {
      bgColor = "lightblue";
    }

    if (
      columnId === "cases_ordered" &&
      ["Case", "Unit / Case"].includes(row.unit_type) &&
      item.cases_originally_ordered &&
      item.cases_originally_ordered !== null &&
      item.cases_originally_ordered !== item.cases_ordered
    ) {
      bgColor = "lightblue";
    }

    if (columnId === "bin" && item.bin_override !== "") {
      bgColor = "lightblue";
    }

    return bgColor;
  };

  return (
    <>
      {(row.picked && hidePicked) || row.hidden ? (
        <Fragment key={`row-${index}`}></Fragment>
      ) : (
        <>
          {/* todo: try to move bg logic to variable dependant or css class and assign class with variable */}
          <TableRow
            hover
            tabIndex={-1}
            key={`row-${index}`}
            {...(row.lot_tracked || row.weight_type === "r/w"
              ? {
                  style: {
                    backgroundColor: row.subitems.some(
                      (sItem) =>
                        !sItem.lot_code ||
                        sItem.lot_code === "" ||
                        sItem.lot_code === null,
                    )
                      ? "lightyellow"
                      : row.weight_type === "r/w"
                        ? "lightblue"
                        : "inherit",
                  },
                }
              : undefined)}
          >
            {columns
              .filter((column) =>
                column.id === "order"
                  ? bulkState
                  : [
                        "price_per_unit",
                        "price_per_case",
                        "fees",
                        "qb_mapping",
                      ].includes(column.id) && hideAdditionals
                    ? false
                    : true,
              )
              .map((column) => {
                const value =
                  column.id === "bin" && row.bin_override !== ""
                    ? row["bin_override"]
                    : row[column.id];
                return (
                  <TableCell
                    key={`column-${column.id}-row-${index}`}
                    style={{
                      maxWidth:
                        column.id === "name"
                          ? xsWidth
                            ? "50vw"
                            : 350
                          : "auto",
                      minWidth:
                        column.id === "name"
                          ? xsWidth
                            ? "50vw"
                            : 350
                          : "auto",
                      position: ["name", "order"].includes(column.id)
                        ? "sticky"
                        : "inherit",
                      left:
                        column.id === "name"
                          ? 0
                          : column.id === "order"
                            ? 358
                            : "inherit",
                      background: ["name", "order"].includes(column.id)
                        ? "white"
                        : "inherit",
                      zIndex: ["name", "order"].includes(column.id)
                        ? 3
                        : "inherit",
                      textAlign: ["order", "scanned"].includes(column.id)
                        ? column.align
                        : "inherit",
                    }}
                  >
                    {column.exposed ? (
                      {
                        input: (
                          <>
                            <input
                              className="inputPickList inputPickListText"
                              name={`${column.id}-${index}`}
                              value={value}
                              onChange={handleChange}
                              disabled={
                                ((column.id === "units_ordered" ||
                                  column.id === "unit_quantity") &&
                                  row.unit_type === "Case") ||
                                ((column.id === "cases_ordered" ||
                                  column.id === "case_quantity") &&
                                  row.unit_type === "Unit") ||
                                ((column.id.includes("quantity") ||
                                  column.id.includes("ordered") ||
                                  column.id.includes("coupon") ||
                                  column.id === "bin") &&
                                  bulkState) ||
                                row.out_of_stock ||
                                locked
                              }
                              type={
                                [
                                  "units_ordered",
                                  "unit_quantity",
                                  "cases_ordered",
                                  "case_quantity",
                                ].includes(column.id)
                                  ? "number"
                                  : "text"
                              }
                              style={{
                                background: overriddenStyle(column.id, row),
                              }}
                            />
                            {!bulkState &&
                            ["Unit", "Unit / Case"].includes(row.unit_type) &&
                            column.id === "units_ordered" &&
                            row.units_originally_ordered &&
                            row.units_originally_ordered !== null &&
                            row.units_originally_ordered !==
                              +row.units_ordered ? (
                              <>{overriddenButton(`${column.id}-${index}`)}</>
                            ) : (
                              <></>
                            )}
                            {!bulkState &&
                            ["Case", "Unit / Case"].includes(row.unit_type) &&
                            column.id === "cases_ordered" &&
                            row.cases_originally_ordered &&
                            row.cases_originally_ordered !== null &&
                            row.cases_originally_ordered !==
                              +row.cases_ordered ? (
                              <>{overriddenButton(`${column.id}-${index}`)}</>
                            ) : (
                              <></>
                            )}
                            {!bulkState &&
                            column.id === "bin" &&
                            row.bin_override !== "" ? (
                              <>{overriddenButton(`${column.id}-${index}`)}</>
                            ) : (
                              <></>
                            )}
                          </>
                        ),
                        checkbox:
                          column.id === "scanned" ? (
                            <Checkbox
                              name={`${column.id}-${index}`}
                              value={value === null ? false : value}
                              checked={
                                value === null || value === true ? false : true
                              }
                              onChange={handleChange}
                              disabled={true}
                              icon={<></>}
                              checkedIcon={<CloseIcon />}
                            />
                          ) : (
                            <Checkbox
                              name={`${column.id}-${index}`}
                              value={value}
                              checked={!!value}
                              onChange={handleChange}
                              disabled={
                                (column.id !== "out_of_stock" &&
                                  row.out_of_stock) ||
                                locked
                              }
                            />
                          ),
                        select:
                          value === false ? (
                            <></>
                          ) : column.id === "name" ? (
                            <>
                              <select
                                className={`inputPickList inputPickListSelect${
                                  row.acceptable_substitutions.length
                                    ? ""
                                    : " inputPickListSelectNoArrow"
                                }`}
                                name={`${column.id}-${index}`}
                                value={row}
                                onChange={handleChange}
                                disabled={
                                  row.out_of_stock || locked || bulkState
                                }
                                style={{
                                  width: `calc(100% - (40px + ${
                                    row.product !== row.original_product
                                      ? 40
                                      : 0
                                  }px + ${row.lot_tracked ? 40 : 0}px)`,
                                }}
                              >
                                <option value={row}>{row.name}</option>
                                {row.hasOwnProperty(
                                  "acceptable_substitutions",
                                ) &&
                                  row.acceptable_substitutions.map((item) => (
                                    <option
                                      key={`_acceptable_substitution_${item.upc}`}
                                      value={`_acceptable_substitution_${item.upc}`}
                                      title={item.upc}
                                    >
                                      {item.name}
                                    </option>
                                  ))}
                                <option value={`_custom_substitution_${index}`}>
                                  Custom substitution
                                </option>
                                <option value={`_out_of_stock_${index}`}>
                                  Out of stock
                                </option>
                                {row.original_product !== row.product ? (
                                  <option
                                    value={`_original_product_${row.original_product}`}
                                  >
                                    {row.original_product_name}
                                  </option>
                                ) : (
                                  <></>
                                )}
                              </select>
                              <Substitution data={row} />
                              {row.lot_tracked ? (
                                <Tooltip title="Lot Tracked Item">
                                  <IconButton
                                    aria-label="edit product"
                                    style={{ cursor: "default" }}
                                  >
                                    <ErrorOutlineIcon />
                                  </IconButton>
                                </Tooltip>
                              ) : (
                                <></>
                              )}
                              <Link
                                href={`/product/${row.upc}`}
                                target="_blank"
                              >
                                <Tooltip title="Edit product">
                                  <IconButton aria-label="edit product">
                                    <OpenInNewIcon />
                                  </IconButton>
                                </Tooltip>
                              </Link>
                            </>
                          ) : column.id === "catch_weight" ? (
                            <Subitems
                              bulkState={bulkState}
                              data={row}
                              locked={locked}
                              handleSubitemsChange={handleSubitemsChange}
                            />
                          ) : column.id === "fees" ? (
                            <Fees
                              bulkState={bulkState}
                              data={row}
                              locked={locked}
                              handleFeesChange={handleFeesChange}
                            />
                          ) : (
                            <Select
                              fullWidth
                              input={<Input />}
                              name={`${column.id}-${index}`}
                              value={value}
                              onChange={handleChange}
                              MenuProps={MenuProps}
                              disabled={row.out_of_stock || locked}
                            >
                              <MenuItem value={value}>{"" + value}</MenuItem>
                            </Select>
                          ),
                        button:
                          column.id === "to_delete" ? (
                            currentUserStore ? (
                              currentUserStore.role_id !== 14 ? (
                                <IconButton
                                  style={{
                                    marginLeft: theme.spacing(1),
                                  }}
                                  variant="contained"
                                  onClick={() =>
                                    handleChange({
                                      target: {
                                        name: `${column.id}-${index}`,
                                        value: "to_delete",
                                      },
                                    })
                                  }
                                  disabled={bulkState || locked}
                                >
                                  {row.to_delete ? (
                                    <AutoDeleteIcon color="inherit" />
                                  ) : (
                                    <DeleteIcon
                                      color={
                                        bulkState || locked
                                          ? "disabled"
                                          : "error"
                                      }
                                    />
                                  )}
                                </IconButton>
                              ) : (
                                <></>
                              )
                            ) : (
                              <></>
                            )
                          ) : (
                            <></>
                          ),
                      }[column.exposedAs || "input"]
                    ) : column.id === "order" && row.dupitems.length ? (
                      <IconButton
                        variant="contained"
                        aria-label={`Item included in orders: ${row.dupitemsOrders.join(
                          ", ",
                        )}`}
                        title={`Item included in orders: ${row.dupitemsOrders.join(
                          ", ",
                        )}`}
                        onClick={() =>
                          handleChange({
                            target: {
                              name: `${column.id}-${index}`,
                              value: "display_dupitems",
                            },
                          })
                        }
                      >
                        <MoreHorizIcon color="inherit" />
                      </IconButton>
                    ) : column.id === "scanned" ? (
                      row.scanned === null ? (
                        <></>
                      ) : row.scanned ? (
                        <CheckIcon />
                      ) : (
                        <CloseIcon />
                      )
                    ) : column.id.includes("price") ||
                      column.id.includes("total") ? (
                      value === null ? (
                        "N/A"
                      ) : (
                        "$" + (+value).toFixed(2)
                      )
                    ) : typeof value === "boolean" ? (
                      "" + value
                    ) : typeof value === "object" && value === null ? (
                      "N/A"
                    ) : (
                      value || 0
                    )}
                    {column.id === "order" ? (
                      <>
                        <br />({row.order_customer})
                      </>
                    ) : (
                      <></>
                    )}
                  </TableCell>
                );
              })}
          </TableRow>
          {!row.dupitems.length ? (
            <></>
          ) : (
            row.dupitems.map((dItem, dIndex) => (
              <TableRow
                hover
                tabIndex={-1}
                key={`row-${index}-child-${dIndex}`}
              >
                {columns
                  .filter((column) =>
                    column.id === "order" ? bulkState : true,
                  )
                  .map((column) => {
                    const value = dItem[column.id];
                    return (
                      <TableCell
                        key={`column-${column.id}-row-${index}`}
                        style={{
                          maxWidth: column.id === "name" ? 350 : "auto",
                          position: column.id === "name" ? "sticky" : "inherit",
                          left: column.id === "name" ? 0 : "inherit",
                          background: "#c0c0c0",
                          color: "#999",
                          zIndex: column.id === "name" ? 3 : "inherit",
                          textAlign:
                            column.id === "order" ? column.align : "inherit",
                          display: dItem.hidden ? "none" : "table-cell",
                        }}
                      >
                        {column.exposed &&
                        ["checkbox", "button"].includes(column.exposedAs) ? (
                          {
                            checkbox:
                              column.id === "scanned" ? (
                                <Checkbox
                                  name={`${column.id}-${index}`}
                                  value={value === null ? false : value}
                                  checked={
                                    value === null || value === true
                                      ? false
                                      : true
                                  }
                                  onChange={handleChange}
                                  disabled={true}
                                  icon={<></>}
                                  checkedIcon={<CloseIcon />}
                                />
                              ) : (
                                <Checkbox
                                  name={`${column.id}-${index}`}
                                  value={value}
                                  checked={!!value}
                                  onChange={handleChange}
                                  disabled={true}
                                />
                              ),
                            button:
                              column.id === "to_delete" ? (
                                currentUserStore ? (
                                  currentUserStore.role_id !== 14 ? (
                                    <IconButton
                                      style={{
                                        marginLeft: theme.spacing(1),
                                      }}
                                      variant="contained"
                                      onClick={() =>
                                        handleChange({
                                          target: {
                                            name: `${column.id}-${index}`,
                                            value: "to_delete",
                                          },
                                        })
                                      }
                                      disabled={true}
                                    >
                                      {row.to_delete ? (
                                        <AutoDeleteIcon color="inherit" />
                                      ) : (
                                        <DeleteIcon
                                          color={
                                            bulkState || locked
                                              ? "disabled"
                                              : "error"
                                          }
                                        />
                                      )}
                                    </IconButton>
                                  ) : (
                                    <></>
                                  )
                                ) : (
                                  <></>
                                )
                              ) : (
                                <></>
                              ),
                          }[column.exposedAs]
                        ) : column.id === "scanned" ? (
                          row.scanned === null ? (
                            <></>
                          ) : row.scanned ? (
                            <CheckIcon />
                          ) : (
                            <CloseIcon />
                          )
                        ) : typeof value === "boolean" ? (
                          "" + value
                        ) : typeof value === "object" && value === null ? (
                          "N/A"
                        ) : (
                          value || 0
                        )}
                        {column.id === "order" ? (
                          <>
                            <br />({dItem.order_customer})
                          </>
                        ) : (
                          <></>
                        )}
                      </TableCell>
                    );
                  })}
              </TableRow>
            ))
          )}
        </>
      )}
    </>
  );
};

export default memo(PickListDetailsRow, (prev, next) => {
  return prev.hidePicked ||
    next.hidePicked ||
    prev.hideAdditionals ||
    next.hideAdditionals ||
    prev.pickerView ||
    next.pickerView ||
    !prev.pickerView ||
    !next.pickerView ||
    prev.row.modified ||
    next.row.modified ||
    prev.filterChange ||
    next.filterChange ||
    prev.row.new ||
    next.row.new ||
    prev.locked ||
    next.locked
    ? false
    : true;
});
